import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { ValidatorForm } from 'components/FormHelpers/FormInputs';
import { openConfirmation } from 'helpers/Confirmation';
// import { CanUserEditRestrictions } from 'appconstants/Permission';
import { openSnackbar } from 'helpers/Notifier';
import { GetFromCtxValue, GetUserFullName, useGetPathProtocol } from 'helpers';
import { httpStatusEnum , TE } from 'appconstants';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers, withState } from 'recompose';
import _ from 'lodash';
import EditRestrictionFor from './EditRestrictionFor';
import { RestrictionForColumns } from '../gridcolumns';

let setEditingFlag;
const RestrictionsFor = ({
  restrictions,
  hasRestrictions,
  saveRestrictionInfo,
  state,
  pspId,
  setState,
  canUserEdit
}) => {
  const RenderEditRow = (row, setEditing) => {
    if (_.isEmpty(state) && !_.isEqual(row, state)) {
      setState({ ...row });
    }

    setEditingFlag = (flg) => {
      setEditing(flg);
      setState({});
    };
    return (
      <EditRestrictionFor
        state={state || row}
        setEditing={setEditing}
        setState={setState}
        defaultRow={row}
      />
    );
  };

  const saveRestriction = () => {
    saveRestrictionInfo({
      ...state,
      dataSource: 'RSS',
      esysStatus: state.esysStatus ? state.esysStatus : 'Active',
      roleType: state.roleType === 'EMPTY' ? null : state.roleType
    }, 'edit');
  };

  const inactivateRestriction = row => {
    saveRestrictionInfo({
      ...row,
      esysStatus: 'Inactive'
    }, 'delete');
  };
  return (
    <ValidatorForm onSubmit={saveRestriction}>
      <GridTable
        tag={`${TE.ID}restrictionfor${TE.TABLE}`}
        title="Restriction For"
        exportTitle={`Restriction For-${useGetPathProtocol()}-Participation`}
        user={GetUserFullName()}
        columns={RestrictionForColumns}
        rows={restrictions || []}
        filterState={{ esysStatus: 'Active' }}
        editMode={canUserEdit && hasRestrictions}
        rowEditable={(row) => (row.dataSource === 'RSS' && canUserEdit)}
        editable
        deletable
        onDelete={inactivateRestriction}
        rowDeletable={(row) => (row.dataSource === 'RSS' && canUserEdit)}
        allowAddRow={canUserEdit && hasRestrictions}
        filterable
        sortable
        enableToolbar
        renderEditRow={RenderEditRow}
        toPdf={false}
      />
    </ValidatorForm>
  );
};


const RestrictionFor = compose(
  withAppContext,
  withState('state', 'setState', {}),
  withHandlers({
    saveRestrictionInfo: props => (postBody, action) => {
      const {
        onSave,
        setState,
        context,
        pspId,
        setRestrictionFlag
      } = props;
      const confirmSave = () => {
        onSave(postBody, pspId).subscribe(resp => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            openSnackbar({
              message: GetFromCtxValue(context, 'PROTOCOL_PARTICIPATION_RESTRICTION_SUCCESS'),
              variant: 'success',
              name: 'restriction'
            });
            setState({});
            setRestrictionFlag(false);
            if (action === 'edit') {
              setEditingFlag(false);
            }
          }
        });
      };
      openConfirmation({
        message: (action === 'edit') ? GetFromCtxValue(context, 'PROTOCOL_PARTICIPATION_RESTRICTION_CONFIRM') : 'Do you want to delete Participation Restriction information?', // PROTOCOL_PARTICIPATION_RESTRICTION_DELETE_CONFIRM
        onAction: confirmSave,
        name: 'restriction'
      });
    }
  })
)(RestrictionsFor);

export default RestrictionFor;
